import { useRouter } from "next/router"
import type { FC, ReactNode } from "react"

import { isCheckoutPage, isLandingPage } from "../utils/routing"
import { useCommunityCustomization } from "../utils/useCommunityCustomization"

interface CommunityContentContainerProps {
  children: ReactNode | ReactNode[]
  childrenWrapperStyles?: string
}

const CommunityContentContainer: FC<CommunityContentContainerProps> = ({
  children,
  childrenWrapperStyles = "",
}) => {
  const router = useRouter()
  const customizationData = useCommunityCustomization()
  if (!customizationData) return null
  const { styles: communityStyles } = customizationData

  const onCheckoutPage = router.pathname.includes("checkout")
  // Checkout needs an explicit mobile width. Without it, this wrapper shrink-wraps to the
  // widest child, which is why narrow Android screens can look like the page lost its padding.
  const contentWrapperWidthStyles = onCheckoutPage
    ? "w-full lg:w-[960px]"
    : `${communityStyles.global.contentBoxShadow} w-[96vw] md:w-full lg:w-[960px]`

  return (
    <div
      className={`flex flex-col h-full w-full items-center pb-0 sm:pb-16 relative ${isCheckoutPage(router.pathname) ? "bg-surfacePrimary" : ""}`}
    >
      <div
        className={`flex flex-col mb-8 sm:mb-0 ${
          isLandingPage(router.pathname)
            ? "mt-[183px] sm:mt-[431px]"
            : `${onCheckoutPage ? "mt-[100px]" : "mt-[154px]"} sm:mt-[128px]`
        }`}
      >
        <div
          className={`flex flex-col ${contentWrapperWidthStyles} ${childrenWrapperStyles}`}
          style={{
            background: isCheckoutPage(router.pathname)
              ? "#FEFEF9"
              : communityStyles.global.contentBg,
          }}
        >
          {children}
        </div>
      </div>
      {/* Spacer for Safari iOS bottom address bar */}
      <div className="sm:hidden" style={{ height: "env(safe-area-inset-bottom)" }} />
    </div>
  )
}

export default CommunityContentContainer
